import React from 'react'
import FooterTwo from '../Components/Footer/FooterTwo'
import HeaderOne from '../Components/Header/HeaderOne'
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';
import PageBanner from '../Components/PageBanner';
import PortfolioOne from "../Components/Portfolio/PortfolioOne";
import PortfolioTwo from "../Components/Portfolio/PortfolioTwo";
import BrandCarouselThree from "../Components/Brands/BrandCarouselThree";
import TeamThree from '../Components/Team/TeamThree';

const ProjectPage = () => {
  return (
    <>
        
        <PageBanner title='Products' bannerBg={bannerBg} currentPage='Products' />
       <TeamThree/>
       <div className='space'/>
        {/* <PortfolioTwo/>
        <BrandCarouselThree/> */}
       
    </>
  )
}

export default ProjectPage;